import { render, staticRenderFns } from "./honor.vue?vue&type=template&id=e63b587a&scoped=true"
import script from "./honor.vue?vue&type=script&lang=js"
export * from "./honor.vue?vue&type=script&lang=js"
import style0 from "./honor.vue?vue&type=style&index=0&id=e63b587a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63b587a",
  null
  
)

export default component.exports